import { post } from '../axios'

interface Params {
  requester_id: string
  farmer_ph_no: string
}

const submitCampaignDetails = async ({
  requester_id,
  farmer_ph_no,
}: Params) => {
  try {
    await post(`campaign/v1/link`, { requester_id, farmer_ph_no })
  } catch {}
}

export default submitCampaignDetails
